import { useSite } from "@/context/SiteContext";
import { FadeUp, SectionHeading } from "@/components/Reveal";

const HowItWorks = () => {
    const { content } = useSite();
    const { steps } = content;

    return (
        <section id="how-it-works" data-testid="how-it-works-section" className="bg-navy py-20 sm:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <SectionHeading eyebrow="Process" heading={steps.heading} sub={steps.sub} light />

                <ol className="relative mt-16 grid gap-10 md:grid-cols-4 md:gap-6">
                    <span className="absolute left-0 right-0 top-6 hidden h-px bg-white/15 md:block" aria-hidden="true" />
                    {steps.items.map((item, i) => (
                        <FadeUp key={item.step} delay={i * 0.12}>
                            <li data-testid={`step-${i}`} className="relative">
                                <div className="flex items-center gap-4 md:block">
                                    <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border-2 border-amberct bg-navy font-display text-sm font-extrabold text-amberct">
                                        {item.step}
                                    </span>
                                    <h3 className="font-display text-xl font-bold text-white md:mt-5">{item.title}</h3>
                                </div>
                                <p className="mt-3 pl-16 text-sm leading-relaxed text-slate-400 md:pl-0">{item.text}</p>
                            </li>
                        </FadeUp>
                    ))}
                </ol>
            </div>
        </section>
    );
};

export default HowItWorks;
